// src/layouts/PrivateLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import NavbarMob from '../components/common/Navbar/NavbarMob';
import Navbar from '../components/common/Navbar/Navbar';
import { useDeviceType } from '../hooks/useDeviceType';

const PrivateLayout = () => {
  const { isMobile } = useDeviceType();

  return (
    <div>
      {/* Show mobile navbar if isMobile is true, otherwise show desktop navbar */}
      {isMobile ? <NavbarMob /> : <Navbar />}
      
      <Outlet /> {/* Renders the child routes like HomePage, Profile, etc */}
    </div>
  );
};

export default PrivateLayout;
